export default "__VITE_ASSET__BrdR703Y__"